// src/components/ContactButton.js
import React, { useState, useContext } from "react";
import "./style.css";
import LanguageContext from "../../context/LanguageContext";

// Import data
const jsonDataEn = require("../data/contact-data-en.json");
const jsonDataFr = require("../data/contact-data-fr.json");

const ContactButton = ({ recipient }) => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [followUp, setFollowUp] = useState("yes");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    setSubmitted(false);
    setFirstName("");
    setEmail("");
    setPhone("");
    setFollowUp("yes");
  };
  const closeModal = () => setIsModalOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const API_BASE = process.env.REACT_APP_API_BASE_URL;
      const payload = { firstName, email, phone, followUp, recipient };

      const response = await fetch(`${API_BASE}/api/contact/full`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to send message.");
      }

      setSubmitted(true);
    } catch (error) {
      console.error("Error sending contact request:", error);
      // Fallback alert; consider inline error state
      alert(data.fail);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <button className="contact-button-sm" onClick={openModal}>
        {data.button}
      </button>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
            {!submitted ? (
              <>
                <h2 className="modal-title-left modal-title">{data.title}</h2>
                <p className="modal-title-left modal-description">{data.description}</p>

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="modal-title-left" htmlFor="firstName">
                      {data.name}: <span className="required-asterisk">*</span>
                    </label>
                    <input id="firstName" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                  </div>

                  <div className="form-group">
                    <label className="modal-title-left" htmlFor="email">
                      {data.email}: <span className="required-asterisk">*</span>
                    </label>
                    <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>

                  <div className="form-group">
                    <label className="modal-title-left" htmlFor="phone">
                      {data.phone}:
                    </label>
                    <input id="phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
                  </div>

                  <div className="form-group">
                    <label className="modal-title-left">{data.follow}</label>
                    <div className="radio-group">
                      <label>
                        <input className="checkbox-color-primary" type="radio" name="followUp" value="yes" checked={followUp === "yes"} onChange={(e) => setFollowUp(e.target.value)} />
                        {data.yes}
                      </label>
                      <label>
                        <input className="checkbox-color-primary" type="radio" name="followUp" value="no" checked={followUp === "no"} onChange={(e) => setFollowUp(e.target.value)} />
                        {data.no}
                      </label>
                    </div>
                  </div>

                  <button type="submit" className="modal-submit-btn" disabled={isSubmitting}>
                    {isSubmitting ? data.submitting : data.submit}
                  </button>
                </form>

                <button className="modal-close" onClick={closeModal}>
                  ×
                </button>
              </>
            ) : (
              <div className="thank-you-message">
                <h3>{data.successTitle}</h3>
                <p>{data.successDescription}</p>
                <button className="modal-submit-btn" onClick={closeModal}>
                  {data.close}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactButton;
